import { render, staticRenderFns } from "./TermFormModal.vue?vue&type=template&id=b5b91906&scoped=true"
import script from "./TermFormModal.vue?vue&type=script&lang=js"
export * from "./TermFormModal.vue?vue&type=script&lang=js"
import style0 from "./TermFormModal.vue?vue&type=style&index=0&id=b5b91906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b91906",
  null
  
)

export default component.exports